export var ACCOUNT_PREFERENCES_FLAGS_QUERY = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "AccountPreferencesPriceMovementFlags"
    },
    "variableDefinitions": [],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "priceMovementFlags"
        },
        "arguments": [],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "acceptPriceShortening"
            },
            "arguments": [],
            "directives": []
          }, {
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "acceptPriceLengthening"
            },
            "arguments": [],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 108,
    "source": {
      "body": "query AccountPreferencesPriceMovementFlags{priceMovementFlags{acceptPriceShortening acceptPriceLengthening}}",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
export var ACCOUNT_PREFERENCES_UPDATE_FLAGS = function ACCOUNT_PREFERENCES_UPDATE_FLAGS(input) {
  return {
    mutation: {
      "kind": "Document",
      "definitions": [{
        "kind": "OperationDefinition",
        "operation": "mutation",
        "name": {
          "kind": "Name",
          "value": "AccountPreferencesUpdatePriceMovement"
        },
        "variableDefinitions": [{
          "kind": "VariableDefinition",
          "variable": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "input"
            }
          },
          "type": {
            "kind": "NonNullType",
            "type": {
              "kind": "NamedType",
              "name": {
                "kind": "Name",
                "value": "UpdatePriceMovementFlagsInput"
              }
            }
          },
          "directives": []
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "updatePriceMovementFlags"
            },
            "arguments": [{
              "kind": "Argument",
              "name": {
                "kind": "Name",
                "value": "input"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "input"
                }
              }
            }],
            "directives": [],
            "selectionSet": {
              "kind": "SelectionSet",
              "selections": [{
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "success"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "error"
                },
                "arguments": [],
                "directives": []
              }, {
                "kind": "Field",
                "name": {
                  "kind": "Name",
                  "value": "state"
                },
                "arguments": [],
                "directives": [],
                "selectionSet": {
                  "kind": "SelectionSet",
                  "selections": [{
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "acceptPriceShortening"
                    },
                    "arguments": [],
                    "directives": []
                  }, {
                    "kind": "Field",
                    "name": {
                      "kind": "Name",
                      "value": "acceptPriceLengthening"
                    },
                    "arguments": [],
                    "directives": []
                  }]
                }
              }]
            }
          }]
        }
      }],
      "loc": {
        "start": 0,
        "end": 192,
        "source": {
          "body": "mutation AccountPreferencesUpdatePriceMovement($input:UpdatePriceMovementFlagsInput!){updatePriceMovementFlags(input:$input){success error state{acceptPriceShortening acceptPriceLengthening}}}",
          "name": "GraphQL request",
          "locationOffset": {
            "line": 1,
            "column": 1
          }
        }
      }
    },
    variables: {
      input: input
    }
  };
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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